import React, { useEffect, useState } from 'react';
import Widget from './Widget';
import {
  testcasesAssignedForExecution,
} from '../../../../../modules/dashboard';
const TestCasesAssignedToUser = ({ projectId }) => {
  const [data, setData] = useState(0);
  const fetchData = async () => {
    try {
      const response = await testcasesAssignedForExecution(projectId);
      setData(response?.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div>
      <Widget title={'TCs Assigned For Execution'} body={data} />
    </div>
  );
};

export default TestCasesAssignedToUser;
